import React from 'react';

interface HeaderLinkProps {
    label: string;
    url: string;
    code?: string;
    updateLevelHeader: (index: number, key: string, value: string) => void;
    index: number;
    toggleLink: () => void;
    setIndex: (index: number) => void;
    setData: (data: string) => void;
    setDynamicLink: (dynamicLink: string) => void;
    removeLevelHeader: (index: number) => void;
    group_under?: string;
    isSecondLevel?: boolean;
    group_list?: { code: string, label: string }[];
    isEditable?: boolean;
    levelName?: string;
}

const HeaderLink: React.FC<HeaderLinkProps> = ({ 
    label, 
    url,
    code = '',
    updateLevelHeader,
    index,
    toggleLink,
    setIndex,
    setData,
    levelName,      
    setDynamicLink,
    removeLevelHeader,
    group_under,
    group_list = [],
    isSecondLevel = false,
    isEditable = true
 }) => {

    return (
        <div className="bg-white border border-black-600 rounded-[5px] px-4 py-4">
            {isSecondLevel && (
                <div className="mb-2">
                    <label className="inline-block mb-2 text-base font-medium">
                        Group Under
                    </label>
                    <select
                        disabled={!isEditable}
                        value={group_under}
                        onChange={(e) =>
                            updateLevelHeader(index, "group_under", e.target.value)
                        }   
                        className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    >
                        {group_list.map((group) => (
                            <option key={group?.code} value={group?.code}>{group?.label}</option>
                        ))}
                    </select>
                </div>
            )}
            <div className="mb-2">
                <label className="inline-block mb-2 text-base font-medium">
                    Label
                </label>
                <input
                    disabled={!isEditable}
                    type="text"
                    value={label}
                    onChange={(e) =>
                        updateLevelHeader(index, "label", e.target.value)
                    }
                    placeholder="Header Label"
                    className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                />
            </div>
            <div className="mb-2">
                <label className="inline-block mb-2 text-base font-medium">
                    Url
                </label>
            </div>
            <div className="flex ">
                <input
                    type="text"
                    disabled={true}
                    value={url}
                    onChange={(e) =>
                        updateLevelHeader(index, "url", e.target.value)
                    }
                    placeholder="Header URL"
                    className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                />
                <div
                    onClick={() => {
                        toggleLink();
                        setIndex(index + 1);
                        setData(levelName);
                        setDynamicLink("");
                    }}
                    className="mb-2 ml-2 text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                    Addlink
                </div>
            </div>
            <div className="flex justify-end mt-2">
                <button
                    onClick={isEditable ? () => removeLevelHeader(index) : null}
                    className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                >
                    Remove Header
                </button>
            </div>
        </div>
    )

}

export default HeaderLink;